import React from 'react';
import { connect } from 'react-redux';
import HoverActionButtonsCell from '@/components/table/HoverActionButtonsCell';
import { editCohort } from '../../actions';

const CohortFilterValue = ({
  category,
  code,
  value,
  canEdit,
  canRead,
  title,
  showEdit,
  width,
}) => (
  <HoverActionButtonsCell
    canEdit={canEdit}
    canRead={canRead}
    content={value}
    exists
    showEdit={() => showEdit(category, code)}
    title={title}
    width={width}
  />
);

const mapDispatchToProps = {
  showEdit: editCohort,
};

export default connect(null, mapDispatchToProps)(CohortFilterValue);
